<template>
  <div class="wm-root">
    <div class="editor-pane" v-if="!resultUrl">
      <div class="pane-header">
        <span class="pane-dot input-dot"/><span class="pane-label">{{ $t('tool.WatermarkRemove.title') }}</span>
        <span class="pane-hint">{{ $t('tool.WatermarkRemove.uploadHint') }}</span>
      </div>
      <el-upload ref="upload" drag action="#" :auto-upload="false" :on-change="handleFile" :limit="1"
        accept="image/png,image/jpeg,image/webp" :file-list="fileList">
        <i class="el-icon-picture-outline" style="font-size:42px;color:#c0c4cc"/>
        <div class="el-upload__text">{{ $t("tool.WatermarkRemove.dropText") }}<em>{{ $t("tool.WatermarkRemove.clickUpload") }}</em></div>
      </el-upload>

      <div v-if="file" class="wm-config">
        <div class="wm-mode-row">
          <span class="wm-ctrl-lbl">{{ $t('tool.WatermarkRemove.lassoMode') }}</span>
          <span :class="['wm-mode-btn',{on:mode==='lasso'}]" @click="setMode('lasso')">{{ $t('tool.WatermarkRemove.lasso') }}</span>
          <span :class="['wm-mode-btn',{on:mode==='brush'}]" @click="setMode('brush')">{{ $t('tool.WatermarkRemove.brushMode') }}</span>
        </div>

        <div class="wm-canvas-wrap">
          <canvas ref="canvas" :key="'cv-'+cvKey"
            @mousedown="onDown" @mousemove="onMove" @mouseup="onUp" @mouseleave="onUp"
            @dblclick="closeLasso" @contextmenu.prevent="closeLasso"
            :style="{maxWidth:canvasStyle.maxW,cursor:'crosshair'}"/>
        </div>

        <div class="wm-ctrls">
          <div class="wm-ctrl-item" v-if="mode==='brush'">
            <span class="wm-ctrl-lbl">{{ $t('tool.WatermarkRemove.brushSize') }}</span>
            <el-slider v-model="brushSize" :min="4" :max="60" style="width:120px"/>
            <code class="wm-ctrl-val">{{ brushSize }}px</code>
          </div>
          <div class="wm-ctrl-item" v-if="mode==='lasso'">
            <span class="wm-ctrl-lbl">{{ lassoPts.length }} 个顶点</span>
            <code class="wm-ctrl-val" v-if="lassoPts.length">{{ $t('tool.WatermarkRemove.dblClickClose') }}</code>
          </div>
          <el-button size="small" @click="clearMask" plain icon="el-icon-delete">{{ $t('tool.WatermarkRemove.clear') }}</el-button>
          <el-button size="small" @click="undoLast" plain icon="el-icon-back" v-if="mode==='lasso'&&lassoPts.length">{{ $t('tool.WatermarkRemove.undoVertex') }}</el-button>
          <el-button size="small" type="primary" :loading="loading" @click="process" icon="el-icon-magic-stick">
            {{ loading ? (cvReady ? $t('tool.WatermarkRemove.processing') : $t('tool.WatermarkRemove.loadEngine')) : $t('tool.WatermarkRemove.btnRemove') }}
          </el-button>
        </div>
      </div>
    </div>

    <!-- 结果 -->
    <div class="ic-result" v-if="resultUrl">
      <div class="ic-result-hd">
        <span class="pane-dot output-dot"/>
        <span class="pane-label">{{ $t('tool.WatermarkRemove.title') }}</span>
      </div>
      <div class="ic-compare">
        <div class="ic-compare-item"><p>{{ $t('tool.WatermarkRemove.original') }}</p><img :src="originalUrl" @error="onImgErr"/></div>
        <div class="ic-compare-item"><p>{{ $t('tool.WatermarkRemove.result') }}</p><img :src="resultUrl" @error="onImgErr"/></div>
      </div>
      <div class="ic-result-actions">
        <el-button size="small" type="primary" icon="el-icon-download" @click="download">{{ $t('tool.WatermarkRemove.download') }}</el-button>
        <el-button size="small" plain @click="reset">{{ $t('tool.WatermarkRemove.reupload') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'WatermarkRemove',props:{config:{type:Object,default:()=>({})}},
  data:()=>({
    file:null,fileList:[],cvKey:0,loading:false,cvReady:false,
    originalUrl:'',resultUrl:'',resultBlobUrl:'',origType:'image/jpeg',brushSize:18,
    img:null,drawing:false,canvasMaxW:'800px',
    mode:'lasso',lassoPts:[],
    overlayCtx:null,overlayCanvas:null,
  }),
  computed:{
    canvasStyle(){return{maxW:this.canvasMaxW,cursor:'crosshair'}}
  },
  methods:{
    setMode(m){
      this.mode=m;
      if(m==='lasso'){this.lassoPts=[];this.drawOverlay()}
    },
    loadCV(cb){
      // 已经初始化好了（cv.Mat 可用）
      if(window.cv&&window.cv.Mat){this.cvReady=true;cb();return}
      var self=this;
      // 等待 cv Promise resolve（openpkg 包装器的工厂返回 Promise）
      var waitCv=function(p){
        var timeout=setTimeout(function(){
          self.$message.error(self.$t('tool.WatermarkRemove.cvTimeout'));
          self.loading=false
        },20000);
        p.then(function(inst){
          clearTimeout(timeout);
          window.cv=inst;self.cvReady=true;cb();
        }).catch(function(e){
          clearTimeout(timeout);
          console.error('[去水印] cv init failed:',e);
          self.$message.error(self.$t('tool.WatermarkRemove.cvLoadFail'));
          self.loading=false
        })
      };
      // 已经加载了：cv 可能是 Promise（openpkg 版）或函数（官方版）
      if(window.cv){
        if(window.cv.then){waitCv(window.cv);return}
        if(typeof window.cv==='function'){waitCv(window.cv());return}
      }
      var s=document.createElement('script');s.async=true;
      var scriptTimeout=setTimeout(function(){
        s.onload=null;s.onerror=null;
        document.head.contains(s)&&document.head.removeChild(s);
        self.$message.error(self.$t('tool.WatermarkRemove.cvTimeout'));
        self.loading=false
      },30000);
      s.onerror=function(){
        clearTimeout(scriptTimeout);
        console.error('[去水印] opencv.js load error');
        self.$message.error('OpenCV引擎文件加载失败，请刷新重试');
        self.loading=false
      };
      s.onload=function(){
        clearTimeout(scriptTimeout);
        if(!window.cv&&typeof module!=='undefined'&&module.exports)window.cv=module.exports;
        if(window.cv&&window.cv.Mat){self.cvReady=true;cb();return}
        if(window.cv&&window.cv.then){waitCv(window.cv);return}
        if(window.cv&&typeof window.cv==='function'){waitCv(window.cv());return}
        console.error('[去水印] cv not found after script load');
        self.$message.error('OpenCV引擎未找到，请刷新重试');
        self.loading=false
      };
      s.src='/opencv.js';document.head.appendChild(s)
    },
    handleFile(f){
      console.log('[去水印] handleFile:',f.raw?{name:f.name,size:f.size,type:f.raw.type}:'no raw')
      if(!f.raw){this.$message.error('文件读取失败');return}
      if(f.size>20*1024*1024){this.$message.error(this.$t('tool.WatermarkRemove.maxSize'));return}
      if(this.originalUrl){console.log('[去水印] revoke old originalUrl');URL.revokeObjectURL(this.originalUrl)}
      if(this.resultUrl){console.log('[去水印] revoke old resultUrl');URL.revokeObjectURL(this.resultUrl);this.resultBlobUrl=''}
      this.file=f.raw;this.origType=f.raw.type||'image/jpeg';this.fileList=[f];this.lassoPts=[];this.cvKey++;this.canvasMaxW='800px';
      this.originalUrl=URL.createObjectURL(f.raw);this.resultUrl='';this.img=null;
      console.log('[去水印] blobUrl created:',this.originalUrl)
      this.overlayCanvas=document.createElement('canvas');
      this.overlayCtx=this.overlayCanvas.getContext('2d');
      var s=this;this.$nextTick(function(){s.initCanvas(s.originalUrl)})
    },
    getCv(){var c=this.$refs.canvas;console.log('[去水印] getCv:',c?'canvas found '+c.width+'x'+c.height:'canvas MISSING');return c},
    initCanvas(dataUrl){
      console.log('[去水印] initCanvas start')
      this.img=new Image();
      var self=this;this.img.onerror=function(e){console.error('[去水印] img onerror',e);self.$message.error(self.$t('tool.WatermarkRemove.imgParseFail'))};
      this.img.onload=()=>{
        var c=this.getCv();if(!c){console.error('[去水印] NO CANVAS');return}
        var w=this.img.width,h=this.img.height;
        var s=Math.min(1,800/w);
        this.canvasMaxW=Math.round(w*s)+'px';
        c.width=w;c.height=h;
        c.style.width=this.canvasMaxW;c.style.height=Math.round(h*s)+'px';
        this.overlayCanvas.width=w;this.overlayCanvas.height=h;
        this.overlayCtx=this.overlayCanvas.getContext('2d');
        c.getContext('2d').drawImage(this.img,0,0);
        console.log('[去水印] canvas ready',w+'x'+h)
      };this.img.src=dataUrl
    },
    pos(e){var c=this.getCv(),r=c.getBoundingClientRect();return{x:(e.clientX-r.left)*(c.width/r.width),y:(e.clientY-r.top)*(c.height/r.height)}},
    // ---- 套索 ----
    onDown(e){
      if(this.mode==='brush'){this.drawing=true;var p=this.pos(e);this.paintBrush(p.x,p.y);return}
      if(this.mode==='lasso'){var pp=this.pos(e);this.lassoPts.push(pp);this.drawOverlay()}
    },
    onMove(e){
      if(this.mode==='brush'&&this.drawing){var p=this.pos(e);this.paintBrush(p.x,p.y);return}
    },
    onUp(){this.drawing=false},
    closeLasso(){
      if(this.mode!=='lasso'||this.lassoPts.length<3)return;
      this.drawing=false;this.fillLasso();this.lassoPts=[];this.drawOverlay()
    },
    drawOverlay(){
      var c=this.getCv();if(!c||!this.img||!this.overlayCanvas)return;
      var ctx=c.getContext('2d');ctx.clearRect(0,0,c.width,c.height);
      ctx.drawImage(this.img,0,0);
      ctx.drawImage(this.overlayCanvas,0,0);
      // 画套索多边形线
      if(this.lassoPts.length>0){
        ctx.strokeStyle='rgba(255,60,60,0.9)';ctx.lineWidth=2;ctx.setLineDash([6,3]);ctx.beginPath();
        ctx.moveTo(this.lassoPts[0].x,this.lassoPts[0].y);
        for(var i=1;i<this.lassoPts.length;i++)ctx.lineTo(this.lassoPts[i].x,this.lassoPts[i].y);
        // 连线到鼠标位置的回环提示
        ctx.stroke();
        // 顶点圆点
        ctx.fillStyle='rgba(255,60,60,0.8)';ctx.setLineDash([]);
        for(var j=0;j<this.lassoPts.length;j++){ctx.beginPath();ctx.arc(this.lassoPts[j].x,this.lassoPts[j].y,4,0,Math.PI*2);ctx.fill()}
      }
    },
    fillLasso(){
      // 将套索多边形填充到 overlay canvas
      var ctx=this.overlayCtx,w=this.overlayCanvas.width,h=this.overlayCanvas.height;
      ctx.fillStyle='#FF0000';ctx.beginPath();
      ctx.moveTo(this.lassoPts[0].x,this.lassoPts[0].y);
      for(var i=1;i<this.lassoPts.length;i++)ctx.lineTo(this.lassoPts[i].x,this.lassoPts[i].y);
      ctx.closePath();ctx.fill()
    },
    undoLast(){this.lassoPts.pop();this.drawOverlay()},
    // ---- 画笔 ----
    paintBrush(x,y){
      // 画在 overlay 上，不污染原图
      this.overlayCtx.fillStyle='#FF0000';this.overlayCtx.beginPath();
      this.overlayCtx.arc(x,y,this.brushSize,0,Math.PI*2);this.overlayCtx.fill();
      // 重新绘制显示层
      this.drawOverlay()
    },
    clearMask(){
      var c=this.getCv();if(c&&this.img){var ctx=c.getContext('2d');ctx.clearRect(0,0,c.width,c.height);ctx.drawImage(this.img,0,0)}
      if(this.overlayCtx){this.overlayCtx.clearRect(0,0,this.overlayCanvas.width,this.overlayCanvas.height)}
      this.lassoPts=[]
    },
    process(){
      console.log('[去水印] process start')
      if(!this.file)return;this.loading=true;
      if(this.mode==='lasso'&&this.lassoPts.length>=3)this.closeLasso();
      this.loadCV(()=>this.doInpaint())
    },
    doInpaint(){
      var c=this.getCv();if(!c){console.error('[去水印] doInpaint NO CANVAS');this.loading=false;return}
      console.log('[去水印] doInpaint canvas',c.width+'x'+c.height)
      var mask=cv.Mat.zeros(c.height,c.width,cv.CV_8UC1);var hasMask=false;
      if(this.overlayCtx){
        var od=this.overlayCtx.getImageData(0,0,c.width,c.height);
        for(var j=0;j<od.data.length;j+=4){
          if(od.data[j]>150&&od.data[j+1]<80&&od.data[j+2]<80){mask.data[j/4]=255;hasMask=true}
        }
      }
      if(!hasMask){this.$message.warning(this.$t('tool.WatermarkRemove.noMask'));this.loading=false;mask.delete();return}
      var self=this;
      var ksize2=new cv.Size(3,3);var k2=cv.getStructuringElement(cv.MORPH_RECT,ksize2);var maskDilated=new cv.Mat();cv.dilate(mask,maskDilated,k2)
      try{
        var src=cv.imread(c);
        var src3=new cv.Mat();cv.cvtColor(src,src3,cv.COLOR_RGBA2RGB);
        var dst=new cv.Mat();cv.inpaint(src3,maskDilated,dst,5,cv.INPAINT_TELEA);
        // 将 RGB dst 转为 RGBA 后写入 canvas，避免 cv.imshow 通道不匹配
        var dst4=new cv.Mat();cv.cvtColor(dst,dst4,cv.COLOR_RGB2RGBA);
        var rc=document.createElement('canvas');rc.width=c.width;rc.height=c.height;
        cv.imshow(rc,dst4);
        console.log('[去水印] inpaint done, creating blob URL');
        if(rc.toBlob){
          rc.toBlob(function(blob){
            if(self.resultBlobUrl)URL.revokeObjectURL(self.resultBlobUrl);
            self.resultUrl=URL.createObjectURL(blob);
            self.resultBlobUrl=self.resultUrl;
            console.log('[去水印] result blob URL created');
            self.loading=false
          },'image/jpeg',0.95)
        }else{
          // 降级：不支持 toBlob 的旧浏览器
          self.resultUrl=rc.toDataURL('image/jpeg',0.95);
          console.log('[去水印] fallback dataUrl, size='+self.resultUrl.length);
          self.loading=false
        }
        src.delete();src3.delete();dst.delete();dst4.delete();mask.delete();maskDilated.delete();k2.delete()
      }catch(e){console.error('inpaint err:',e);self.$message.error(e&&e.message||String(e));self.loading=false}
    },
    reset(){if(this.resultUrl)URL.revokeObjectURL(this.resultUrl);this.resultUrl='';this.resultBlobUrl='';this.file=null;this.fileList=[];this.originalUrl='';this.img=null;this.canvasMaxW='800px';this.lassoPts=[];if(this.overlayCtx){this.overlayCtx.clearRect(0,0,this.overlayCanvas.width,this.overlayCanvas.height);this.overlayCanvas=null;this.overlayCtx=null}var c=this.$refs.canvas;if(c){c.width=0;c.height=0}},
    onImgErr(){this.$message.error(this.$t('tool.WatermarkRemove.imgLoadFail'))},
    download(){var a=document.createElement('a');document.body.appendChild(a);a.href=this.resultUrl;a.download='no_watermark.jpg';a.click();document.body.removeChild(a)},
    doAction(a){if(a==='clear')this.reset()}
  }
}
</script>

<style scoped>
.wm-root{display:flex;flex-direction:column;gap:16px}

.editor-pane{background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px;min-width:0;overflow:hidden}
.pane-header{display:flex;align-items:center;gap:8px;margin-bottom:12px;flex-wrap:wrap}
.pane-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0}
.input-dot{background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4)}
.output-dot{background:#43e97b;box-shadow:0 0 6px rgba(67,233,123,.4)}
.pane-label{font-size:13px;font-weight:700;color:#1a1f36}
.pane-hint{font-size:11px;color:#b0b8c4;margin-left:auto;white-space:nowrap}
.wm-root ::v-deep .el-upload{width:100%}
.wm-root ::v-deep .el-upload-dragger{display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:170px;max-width:100%;width:100%;box-sizing:border-box}

.wm-config{margin-top:14px}
.wm-mode-row{display:flex;align-items:center;gap:8px;margin:10px 0 8px}
.wm-mode-btn{padding:5px 12px;border-radius:5px;font-size:12px;cursor:pointer;border:1.5px solid #e1e5e9;color:#606266;transition:.12s}
.wm-mode-btn:hover{border-color:#4e7cff;color:#4e7cff}
.wm-mode-btn.on{background:#e8f0fe;border-color:#4e7cff;color:#4e7cff;font-weight:600}
.wm-canvas-wrap{text-align:center;margin-bottom:12px}
.wm-canvas-wrap canvas{border:1px solid #e4e7ed;border-radius:6px;display:block;margin:0 auto}
.wm-ctrls{display:flex;align-items:center;gap:12px;flex-wrap:wrap}
.wm-ctrl-item{display:flex;align-items:center;gap:6px}
.wm-ctrl-lbl{font-size:12px;color:#909399;white-space:nowrap}
.wm-ctrl-val{font-size:12px;color:#c0c4cc;font-family:monospace}

.ic-result{background:#f0f9eb;border:1px solid #e1f3d8;border-radius:12px;padding:20px 24px}
.ic-result-hd{display:flex;align-items:center;gap:8px;margin-bottom:16px}
.ic-result-actions{display:flex;gap:8px;margin-top:16px}
.ic-compare{display:flex;gap:20px}
.ic-compare-item{flex:1;text-align:center}
.ic-compare-item p{font-size:12px;color:#909399;margin-bottom:8px;font-weight:600}
.ic-compare-item img{max-width:100%;max-height:320px;border:1px solid #e4e7ed;border-radius:8px;background:#fff}

@media(max-width:640px){
  .editor-pane{padding:12px 14px}
  .pane-hint{display:none}
  .wm-root ::v-deep .el-upload-dragger{min-height:140px;padding:20px 12px}
  .wm-root ::v-deep .el-upload__text{font-size:12px}
  .ic-compare{flex-direction:column}
  .ic-result{padding:14px 16px}
  .wm-ctrls{flex-direction:column;align-items:flex-start}
}
</style>
